import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICost, ILocation, IVideoCost } from "./orderApiSlice";
import dayjs from "dayjs";

// export interface ILocation {
//   LocationId: number | null;
//   Location: String | null;
//   Cost: number | null;
// }

// export interface ICost {
//   Id: number | null;
//   OrderId: number | null;
//   SeminarOrderItemId: number | null;
//   EventId: number | null;
//   CostId: number | null;
//   CostName: string | null;
//   Cost: number | null;
// }

// export interface IMembership {
//   EventType: string | null;
//   Id: number | null;
//   SectionName: string | null;
//   Fee: number | null;
// }

// interface ISection {
//   Fee: number;
//   Id: number;
//   SectionDescription: string;
//   SectionName: string;
//   isSelected: boolean;
// }

export interface IGuestOrderItem {
  OrderItemId: number | null;
  EventId: string | null | number;
  MemberCodeId: number | null;
  EventName: string;
  Location: ILocation | null;
  Costs: ICost[] | null;
  VideoCost: IVideoCost[] | null;
  OrderType: string | null;
  ParticipantType: string | null;
  IsAttended: number | null;
  IsAttendenceUpdated: number | null;
  Description: string | null;
  UniqueEventId: string | null;
  StartDateTime: string | null;
  EndDateTime: string | null;
  CostVariationTotalCost: number | null;
  EventVariationTotalCost: number | null;
  MemberCode: string | null;
  MemberCodeFee: number | null;
  MemberCodeDesc: string | null;
  EventType: string | null;
}

export interface IGuestOrder {
  FirstName: string | null;
  LastName: string | null;
  Gender: string | null;
  // DateOfBirth: string | null;
  PhoneNumber: string | null;
  Email: string | null;
  Address1: string | null;
  Address2: string | null;
  City: string | null;
  State: string | null;
  Zipcode: string | null;
  MemberId: number | null;
  OrderId: number | null;
  TotalAmount: number ;
  AmountPaid:number,
  CouponAmount:number,
  DueAmount:number |null,
  TransactionType: string | null; // this is Transaction Type
  DatePaid: string | null;
  CheckNumber: string | null;
  LateFee: number | null;
  AuthCode: string | null;
  Comments: string | null;
  NoInvoice: boolean | null;
  Orders: IGuestOrderItem[] | [];
  OrderType: string | null;
  IsGuest: boolean | null;
}

export const initalGuestOrderItem: IGuestOrderItem = {
  // Id: null,
  OrderItemId: null,
  EventId: "",
  MemberCodeId: null,
  EventName: "",
  Location: null,
  Costs: [],
  VideoCost: [],
  OrderType: "",
  ParticipantType: "",
  IsAttended: null,
  IsAttendenceUpdated: null,
  Description: "",
  UniqueEventId: "",
  StartDateTime: "",
  EndDateTime: "",
  CostVariationTotalCost: null,
  EventVariationTotalCost: null,
  MemberCode: "",
  MemberCodeFee: null,
  MemberCodeDesc: "",
  EventType: "",
};

const initialState: IGuestOrder = {
  FirstName: null,
  LastName: null,
  Gender: null,
  PhoneNumber: null,
  Email: null,
  Address1: null,
  Address2: null,
  City: null,
  State: null,
  Zipcode: null,
  MemberId: null,
  OrderId: null,
  AmountPaid:0,
  CouponAmount:0,
  DueAmount:null,
  TotalAmount: 0,
  TransactionType: null, // this is Transaction Type
  DatePaid: dayjs().format("YYYY-MM-DD"),
  CheckNumber: null,
  LateFee: null,
  AuthCode: null,
  Comments: null,
  NoInvoice: false,
  Orders: [initalGuestOrderItem],
  OrderType: null,
  IsGuest: null,
};

type BodyType = {
  key: string;
  value: string | number | boolean | ILocation;
};

type GuestOrderItemBody = {
  key: string;
  value: IGuestOrderItem;
};

type GuestOrderItemCostsBody = {
  key: string;
  value: ICost;
};

type GuestOrderItemVideoCostsBody = {
  key: string;
  value: IVideoCost;
};

export const guestOrderApiSlice = createSlice({
  name: "guestOrderapislice",
  initialState,
  reducers: {
    storeResetGuestOrder: () => {
      return initialState;
    },

    storeUpdateGuestOrder: (state: any, action: PayloadAction<BodyType>) => {
      console.log(
        "key&value-storeUpdateGuestOrder:",
        action.payload.key,
        ":",
        action.payload.value
      );
      // state[action.payload.key] = action.payload.value;1
      const newState = {
        ...state,
        [action.payload.key]: action.payload.value,
      };
      return newState;
    },

    storeAddGuestOrderItemCosts: (
      state: any,
      action: PayloadAction<GuestOrderItemCostsBody>
    ) => {
      const { value } = action.payload;

      // If Orders array is initially empty, create a new order item with the new cost
      if (state.Orders.length === 0) {
        return {
          ...state,
          Orders: [{ ...initalGuestOrderItem, Costs: [value] }],
        };
      }

      console.log("value-storeAddGuestOrderItemCosts:", action.payload.value);
      // Copy the existing order item array
      const updatedOrders = {
        ...state,
        Orders: state.Orders.map((orderItem: IGuestOrderItem) => ({
          ...orderItem,
          Costs: [...(orderItem.Costs || []), value], // Append the new cost object to the Costs array
        })),
      };
      console.log("updatedOrders", updatedOrders);
      return updatedOrders;
    },

    storeRemoveGuestOrderItemCosts: (
      state: any,
      action: PayloadAction<GuestOrderItemCostsBody>
    ) => {
      const { value } = action.payload;

      const index = state.Orders[0].Costs.findIndex(
        (cost: ICost) => (cost.CostId == undefined) ? cost.EventCostVarId === value.CostId : cost.CostId === value.CostId
      );

      // If the index is valid (i.e., cost object exists in the array)
      if (index !== -1) {
        // Create a new array with the cost object removed
        const updatedCosts = [
          ...state.Orders[0].Costs.slice(0, index),
          ...state.Orders[0].Costs.slice(index + 1),
        ];

        const updatedOrders = {
          ...state,
          Orders: [
            {
              ...state.Orders[0],
              Costs: updatedCosts,
            },
          ],
        };

        console.log("updatedGuestOrders", updatedOrders);
        return updatedOrders;
      }

      // Copy the existing order item array
      // const updatedOrders = {
      //   ...state,
      //   Orders: (state.Orders[0] = {
      //     ...state.Orders[0],
      //     Costs: [...state.Orders[0].Costs.slice(0, index)],
      //   }),
      // };
      return state;
    },

    storeAddGuestOrderItemVideoCost: (
      state: any,
      action: PayloadAction<GuestOrderItemVideoCostsBody>
    ) => {
      const { value } = action.payload;

      // If Orders array is initially empty, create a new order item with the new cost
      if (state.Orders.length === 0) {
        return {
          ...state,
          Orders: [{ ...initalGuestOrderItem, VideoCost: [value] }],
        };
      }

      console.log("value-storeAddOrderItemVideoCosts:", action.payload.value);
      // Copy the existing order item array
      const updatedOrders = {
        ...state,
        Orders: state.Orders.map((orderItem: IGuestOrderItem) => ({
          ...orderItem,
          // VideoCost: [...(orderItem.VideoCost || []), value], // Append the new cost object to the Costs array
          VideoCost: [value], // Append the new cost object to the Costs array
        })),
      };
      console.log("updatedOrders", updatedOrders);
      return updatedOrders;
    },

    storeRemoveGuestOrderItemVideoCost: (
      state: any,
      action: PayloadAction<GuestOrderItemVideoCostsBody>
    ) => {
      const { value } = action.payload;

      // const index = state.Orders[0].VideoCost.findIndex(
      //   (videoCost: IVideoCost) => videoCost.CostName === value.CostName
      // );

      // // If the index is valid (i.e., cost object exists in the array)
      // if (index !== -1) {
      //   // Create a new array with the cost object removed
      //   const updatedVideoCosts = [
      //     ...state.Orders[0].VideoCost.slice(0, index),
      //     ...state.Orders[0].ViodeCost.slice(index + 1),
      //   ];

      const updatedOrders = {
        ...state,
        Orders: [
          {
            ...state.Orders[0],
            VideoCost: [],
          },
        ],
      };

      console.log("updatedOrders", updatedOrders);
      return updatedOrders;
    },

    storeAssignGuestOrderItem: (
      state: any,
      action: PayloadAction<GuestOrderItemBody>
    ) => {
      console.log(
        "key&value-storeUpdateOrderItem:",
        action.payload.key,
        ":",
        action.payload.value
      );
      const { key, value } = action.payload;
      const newState = {
        ...state,
        [action.payload.key]: [action.payload.value],
      };
      console.log("checking OrderItemID:", newState.Orders);
      return newState;
    },

    storeUpdateGuestOrderItem: (
      state: any,
      action: PayloadAction<BodyType>
    ) => {
      console.log(
        "key&value-storeUpdateGuestOrderItem:",
        action.payload.key,
        ":",
        action.payload.value
      );
      const { key, value } = action.payload;

      const updatedOrders = {
        ...state,
        Orders: [
          {
            ...state.Orders[0],
            [action.payload.key]: action.payload.value,
          },
        ],
      };

      return updatedOrders;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  storeResetGuestOrder,
  storeUpdateGuestOrder,
  storeAddGuestOrderItemCosts,
  storeRemoveGuestOrderItemCosts,
  storeAddGuestOrderItemVideoCost,
  storeRemoveGuestOrderItemVideoCost,
  storeAssignGuestOrderItem,
  storeUpdateGuestOrderItem,
} = guestOrderApiSlice.actions;

export default guestOrderApiSlice.reducer;
